// KL - weight loss personal trainer.
const content = {
    slug: 'weight-loss-personal-trainer',
    title: 'Weight Loss Personal Trainer in KL | Plans That Fit Malaysian Food',
    description: (c) =>
        `Weight loss personal training in Kuala Lumpur: strength sessions plus eating habits that work with mamak, hawker and festive food. From ${c.money(c.lowest, 0)} a session.`,
    eyebrow: 'KL · Weight loss',
    h1: 'Weight Loss Personal Trainer in Kuala Lumpur',
    lead: 'Nasi lemak for breakfast, mamak sessions at night, open houses every festive season - Malaysian food is part of life, so your weight loss plan has to work with it, not against it.',
    image: 'diet.jpg',
    imageAlt: 'Balanced meal as part of a weight loss plan',
    facts: ['Strength-led training', 'No food is banned', 'Festive-season plans'],
    ctaLabel: 'Start a weight loss plan',
    matchSummary: 'a weight loss personal trainer in KL',
    packagesTitle: 'Weight loss packages',
    packagesIntro: 'Three sessions a week in the first two months works best; the 30-session package covers about ten weeks.',
    sections: [
        {
            title: 'Eating habits that work in Malaysia',
            cards: [
                { title: 'At the mamak', body: 'Roti canai once in a while, not daily; teh o kosong or ais limau instead of teh tarik with condensed milk.' },
                { title: 'At hawker stalls', body: 'More lauk, less rice; soup noodles over fried; ask for kurang manis.' },
                { title: 'Festive season', body: 'Raya, CNY and Deepavali open houses are planned in - lighter days before and after, and a walk afterwards.' },
                { title: 'Drinks', body: 'The easiest win: sugary drinks are often the biggest source of extra calories.' },
            ],
            cardColumns: 2,
        },
        {
            title: 'The training side',
            tone: 'muted',
            steps: [
                { title: 'Measure', body: 'Weight, waist and a fitness check in the first session.' },
                { title: 'Lift', body: 'Two to three strength sessions a week to keep muscle while you lose fat.' },
                { title: 'Walk', body: 'A daily step goal - mall walking on rainy days, the park in the morning.' },
                { title: 'Adjust', body: 'Check-ins every two weeks; the plan changes when progress slows.' },
            ],
        },
    ],
    faqs: [
        {
            question: 'How much weight can I lose with a personal trainer?',
            answer: 'A healthy pace is around 0.5 to 1 kg a week. The first weeks are often faster. Your trainer sets a target after your first session.',
        },
        {
            question: 'Do I have to stop eating nasi lemak?',
            answer: 'No. Portion, frequency and what you drink with it matter more than cutting out favourite foods.',
        },
        {
            question: 'Can I train in my condo gym?',
            answer: 'Yes - condo gyms have everything a weight loss programme needs.',
        },
    ],
    schema: { name: 'Weight Loss Personal Training in Kuala Lumpur' },
}

export default content
